import {LIMPAR_REPASSE_VENDA_SITE} from '../types'

export default function limparRepasseVenda () {
  return {
    type: LIMPAR_REPASSE_VENDA_SITE,
  }
}
